import { render, staticRenderFns } from "./dataManagement.vue?vue&type=template&id=79dec7c6&scoped=true&"
import script from "./dataManagement.vue?vue&type=script&lang=js&"
export * from "./dataManagement.vue?vue&type=script&lang=js&"
import style0 from "./dataManagement.vue?vue&type=style&index=0&id=79dec7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dec7c6",
  null
  
)

export default component.exports